module.exports = __webpack_public_path__ + "img/advantage-item-01.659d563e.png";